import { Component, Vue } from 'vue-property-decorator';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { SelectItem } from '@/interfaces/components/SelectItem';
@Component
export default class CustomerGroup extends Vue {
  get customerGroups() {
    return [
      { text: this.$t('customerGroups.default'), value: '' },
      { text: this.$t('customerGroups.subway'), value: CustomerGroupEnum.Subway },
      { text: this.$t('customerGroups.subwayTerminal'), value: CustomerGroupEnum.SubwayTerminal },
      { text: this.$t('customerGroups.subwayFr'), value: CustomerGroupEnum.SubwayFr },
      { text: this.$t('customerGroups.db'), value: CustomerGroupEnum.DB },
      { text: this.$t('customerGroups.lunchroom'), value: CustomerGroupEnum.Lunchroom },
      { text: this.$t('customerGroups.fbf'), value: CustomerGroupEnum.FoodByFriends },
      { text: this.$t('customerGroups.weilands'), value: CustomerGroupEnum.Weilands },
      { text: this.$t('customerGroups.cinemaxx'), value: CustomerGroupEnum.Cinemaxx },
      { text: this.$t('customerGroups.district'), value: CustomerGroupEnum.District },
      { text: this.$t('customerGroups.kochloeffel'), value: CustomerGroupEnum.Kochloeffel },
      { text: this.$t('customerGroups.immergruen'), value: CustomerGroupEnum.Immergruen },
      { text: this.$t('customerGroups.myMonza'), value: CustomerGroupEnum.MyMonza },
      { text: this.$t('customerGroups.aspasia'), value: CustomerGroupEnum.ASPASIA },
    ];
  }

  get scopedCustomerGroups() {
    if (this.$isAdmin()) {
      return this.customerGroups;
    }
    if (this.$hasCustomerGroup()) {
      return this.customerGroups.filter((i: SelectItem) => i.value === '' || i.value === this.$getCustomerGroup());
    }

    return [];
  }
}
